export default "__VITE_ASSET__eb463a92__"